import { trigger, transition, style, animate, state } from '@angular/animations';
import { appConfig } from 'src/config';

const _routeTime = appConfig.route_time;

export const pageTransitionAnimation =
    trigger('routeAnimations', [
        state('hidden', style({opacity: 0})),
        state('visible', style({opacity: 1})),
        transition('* => visible', [
            style({ opacity: 0 }),
            animate('{{enterTime}} ease-in-out', style({ opacity: 1 }))
        ],
        {params: {enterTime: _routeTime}}),
        transition('* => hidden', [
            style({ opacity: 1 }),
            animate('0.5s', style({ opacity: 0 }))
        ])
    ]);
